var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 5.49473L15.8438 7.07812V3.8125C15.8438 3.0541 15.2271 2.4375 14.4688 2.4375H1.75C0.991602 2.4375 0.375 3.0541 0.375 3.8125V16.1875C0.375 16.9459 0.991602 17.5625 1.75 17.5625H14.4688C15.2271 17.5625 15.8438 16.9459 15.8438 16.1875V12.9219L18.5938 14.5053C19.0514 14.7695 19.625 14.4387 19.625 13.9123V6.08984C19.625 5.56133 19.0514 5.23047 18.5938 5.49473ZM14.2969 16.0156H1.92188V3.98438H14.2969V16.0156ZM18.4118 12.5882L15.8235 11.2941L15.8438 8.85918L18.4118 7.41177V12.5882ZM3.46875 6.73438H5.875C5.96953 6.73438 6.04688 6.65703 6.04688 6.5625V5.53125C6.04688 5.43672 5.96953 5.35938 5.875 5.35938H3.46875C3.37422 5.35938 3.29688 5.43672 3.29688 5.53125V6.5625C3.29688 6.65703 3.37422 6.73438 3.46875 6.73438Z",
    fill: "#404041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.cacca476b2ede76a9785a8dd31aaf0b9.svg";
export { ForwardRef as ReactComponent };